<template>
    <ContabiliDesktop v-if="!$vuetify.breakpoint.mobile" />
    <ContabiliMobile v-else/>
  </template>
  
  <script>
  import ContabiliDesktop from "@/components/Contabili/desktop/contabili_desktop_main.vue"
  import ContabiliMobile from "@/components/Contabili/mobile/contabili_mobile_main.vue"
  export default {
    components: {
      ContabiliDesktop,
      ContabiliMobile
    },
  };
  </script>